import React from 'react';
import classnames from 'classnames';
import ModalCardHead from './Card.Head.js';
import ModalCardBody from './Card.Body.js';
import ModalCardFoot from './Card.Foot.js';
import ModalCardTitle from './Card.Title.js';

const ModalCard = ({ className, children, ...props }) => {
  return (
    <div {...props} className={classnames('modal-card', className)}>
      {children}
    </div>
  );
};

ModalCard.Head = ModalCardHead;
ModalCard.Body = ModalCardBody;
ModalCard.Foot = ModalCardFoot;
ModalCard.Title = ModalCardTitle;

export default ModalCard;
